<template>
  <div>
    <h2>Family & Property Events</h2>
    <div class="selection-details">
      Noteworthy historical or personal events that impacted the property or its inhabitants.
    </div>
    <div class="row top-section">
      <FormTable
          :rows="events"
          :columns="eventColumns"
          :editing-index="entryBeingEdited"
          sort-key="yearRecorded"
          add-label="an event"
          :show-form="showForm"
          @edit="editEvent"
          @delete="removeEventFromTable"
          @toggle-form="toggleForm"
      />
    </div>
    <div v-if="showForm" class="row">
      <div class="col-lg-2 col-sm-12">
        <ValidationField
            label="Year"
            type="number"
            v-model="eventYear"
            validation-type="year"
            :should-validate="shouldValidateYear"
            @validated="checkIfDoneValidating"
        />
      </div>
      <div class="col-12">
        <label for="inputEventDescription" class="form-label">Description</label>
        <textarea v-model="eventDescription" type="text" class="form-control" id="inputEventDescription"></textarea>
      </div>
      <div class="col-12 save-event-button">
        <button
            v-if="this.entryBeingEdited !== null"
            class="btn btn-secondary cancel-edit-button"
            @click="clearFormFields"
        >
          Cancel
        </button>
        <button class="btn btn-secondary" @click="addEventClicked">{{ eventActionString }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import {progressStatus} from '@/helpers/utils';
import {mapGetters} from 'vuex';
import {mapActions} from 'vuex';
import ValidationField from '@/components/ValidationField.vue';
import FormTable from '@/components/add/FormTable.vue';
import {ROUTENAMES} from "@/helpers/constants";

export default {
  name: "EventForm",
  components: { ValidationField, FormTable },
  data() {
    return {
      showForm: false,
      events: [],
      eventColumns: [
        { label: 'Year', key: 'yearRecorded' },
        { label: 'Description', key: 'eventDesc' },
      ],
      eventYear: null,
      eventDescription: null,
      shouldValidateYear: false,
      numValidFields: 0,
      expectedValidFields: 1,
      entryBeingEdited: null,
    }
  },
  props: {
    triggerSaveDraft: { type: Boolean, default: false },
  },
  mounted() {
    const eventData = this.getHomeFormSections.events?.data;
    if (eventData && eventData.length > 0) {
      this.events = eventData;
    } else {
      this.$emit('disableNext', 'Please add at least one event.');
    }
  },
  beforeUnmount() {
    this.savePageContents();
  },
  watch: {
    triggerSaveDraft(to){
      if(to){
        this.savePageContents();
      }
    },
    wholeFormEmpty(to) {
      if (to) {
        this.$emit('disableNext', 'Please add at least one event.');
        this.updateFormSection({ key: 'events', data: { status: null } });
      } else {
        this.$emit('disableNext', null);
        this.updateFormSection({ key: 'events', data: { status: progressStatus.DONE } });
      }
    },
    eventYear() {
      this.shouldValidateYear = false;
    },
    numValidFields(to) {
      if (this.shouldValidateYear && to === this.expectedValidFields) {
        // Save and clear
        this.addEvent();
      }
    },
  },
  computed: {
    ...mapGetters(['getHomeFormSections']),
    eventActionString() {
      return this.entryBeingEdited !== null ? 'Update Event' : 'Save Event';
    },
    wholeFormEmpty() {
      return this.events.length < 1;
    }
  },
  methods: {
    ...mapActions(['updateFormSection']),
    savePageContents() {
      if(this.$route.name === ROUTENAMES.ADD_HOME) {
        this.updateFormSection({ key: 'events', data: { data: this.events } });
        if (this.wholeFormEmpty) {
          this.updateFormSection({ key: 'events', data: { status: null } });
        }
        this.$emit('disableNext', null);
      }
    },
    toggleForm() {
      this.showForm = !this.showForm
    },
    addEventClicked() {
      this.shouldValidateYear = true;
      this.numValidFields = 0;
    },
    addEvent() {
      const newEvent = {eventDesc: this.eventDescription, yearRecorded: this.eventYear};
      if (this.entryBeingEdited === null) {
        this.events.push(newEvent);
      } else {
        this.events[this.entryBeingEdited] = newEvent;
      }
      this.clearFormFields();
    },
    clearFormFields() {
      this.eventYear = null;
      this.eventDescription = null;
      this.entryBeingEdited = null;
    },
    checkIfDoneValidating(result) {
      if (result.valid) {
        this.numValidFields += 1;
      }
    },
    removeEventFromTable(index) {
      this.events.splice(index, 1);
      this.entryBeingEdited = null;
    },
    editEvent(index) {
      this.showForm = true;
      this.entryBeingEdited = index;
      const entryToEdit = this.events[index];
      this.eventYear = entryToEdit.yearRecorded;
      this.eventDescription = entryToEdit.eventDesc;
    },
  },
}
</script>

<style scoped>
.top-section {
  margin: 0 0 1rem 0;
}

.save-event-button {
  margin-top: 1rem;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}


</style>